// extracted by mini-css-extract-plugin
var _1 = "kLpweRAXnL2w9HzobDGb";
var _2 = "cXn2LWvDHWsmdy2DuelC";
export { _1 as "container", _2 as "image" }
